<template>
  <v-container>
    <v-layout row wrap>
    <v-flex xs12 md8 offset-md2>
    <v-card class="elevation-4">
        <v-card-title class="teal lighten-1">
          <div class="white--text headline">Nome</div>
        </v-card-title>
      <v-card-text>
          <v-layout row wrap v-if="prazoTrue">
            <v-flex xs12>
              <v-text-field
                id="nome"
                name="nome"
                label="Primeiro Nome"
                v-model="usuario.nome"
                @input.native="updateDados('nome', $event.target.value)"
                hint="Atenção às maiúsculas"
                :rules="[rules.nome, rules.maiuscula, rules.minuscula, rules.primeiraletra]"
                required></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                id="sobrenome"
                name="sobrenome"
                label="Sobrenome"
                v-model="usuario.sobrenome"
                @input.native="updateDados('sobrenome', $event.target.value)"
                hint="Atenção às maiúsculas"
                :rules="[rules.sobrenome, rules.maiuscula, rules.minuscula]"
                required></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-else>
            <v-flex xs12>
            <h1 class="display-1">Prazo encerrado</h1>
            <h3>A abertura do sistema pode acarretar atrazo na entrega do convite.</h3>
            </v-flex>
          </v-layout>
      </v-card-text>
        <v-card-text class="grey lighten-3">
          <span>Como será impresso seu nome no convite:</span>
          <div class="nome text-xs-center mt-4">{{ usuario.nome }}</div>
          <div class="sobrenome text-xs-center">{{ usuario.sobrenome }}</div>
        </v-card-text>
    </v-card>

    <v-card class="mt-3 elevation-4">
      <v-card-title class="teal lighten-1">
        <span class="white--text headline">Contato</span>
      </v-card-title>
      <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field type="tel" v-mask="['(##) ####-####', '(##) #####-####']" label="Telefone" prepend-icon="phone" v-model="usuario.telefone" @input.native="updateDados('telefone', $event.target.value)"></v-text-field>
            </v-flex>
          </v-layout>
      </v-card-text>
    </v-card>

    <v-card class="mt-3 elevation-4">
      <v-card-title class="teal lighten-1">
        <span class="white--text headline">Pais</span>
      </v-card-title>
      <v-card-text>
          <v-layout row wrap v-if="prazoTrue">
            <v-flex xs12 sm8>
              <v-text-field id="pai" name="pai" label="Nome do Pai" v-model="usuario.pai" @input.native="updatePais('pai', $event.target.value)"></v-text-field>
            </v-flex>
            <v-flex xs12 sm4>
              <v-checkbox label="in memoriam" v-model="usuario.paiim" light @click="updatePaisIm('paiim', !usuario.paiim)"></v-checkbox>
            </v-flex>
          <v-divider class="mb-3"></v-divider>
            <v-flex xs12 sm8>
              <v-text-field id="mae" name="mae" label="Nome do Mãe" v-model="usuario.mae" @input.native="updatePais('mae', $event.target.value)"></v-text-field>
            </v-flex>
            <v-flex xs12 sm4>
              <v-checkbox label="in memoriam" v-model="usuario.maeim" light @click="updatePaisIm('maeim', !usuario.maeim)"></v-checkbox>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-else>
            <v-flex xs12 sm8>
              <h3>{{usuario.pai}}
              <span v-if="usuario.paiim"> (in memoriam)</span>
            </h3>
            <h3>{{usuario.mae}}
              <span v-if="usuario.maeim"> (in memoriam)</span>
            </h3>
            </v-flex>
          </v-layout>
      </v-card-text>
    </v-card>
    </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from "moment";
import { mask } from "vue-the-mask";

moment.locale("pt-BR");
export default {
  directives: { mask },
  data() {
    return {
      usuario: {},
      user: {},
      prazo: "",
      prazoTrue: true,
      emailkey: "",
      rules: {
        nome: value => !!value || "Nome obrigatório.",
        sobrenome: value => !!value || "Sobrenome obrigatório.",
        maiuscula: value => {
          let pattern = /\w*[A-Z]\w*[A-Z]\w*/g;
          return !pattern.test(value) || "Não digite tudo em caixa alta.";
        },
        minuscula: value => {
          let pattern = /[A-Z]/g;
          return pattern.test(value) || "Não digite tudo em caixa baixa.";
        },
        primeiraletra: value => {
          let pattern = /[A-Z]/g;
          return (
            pattern.test(value) ||
            "Primeira letra do nome tem que ser maiúscula."
          );
        }
      }
    };
  },
  mounted() {
    this.$auth.onAuthStateChanged(user => {
      if (user) {
        this.user = user;
        let email = user.email;
        this.emailkey = email.replace(/[.]/g, ",");
        this.$bindAsObject("usuario", this.$db.ref(`users/${this.emailkey}`));
        const ref = this.$db.ref(`users/${this.emailkey}`);
        ref.once("value", snap => {
          this.projeto = snap.val().projeto.atual;
          let prazo = snap.val().projeto.projetos[this.projeto].prazo;
          this.prazo = moment(prazo, "DD/MM/YYYY").format("DD/MM/YYYY");
          this.prazoTrue = moment(prazo, "DD/MM/YYYY").isAfter(moment());
          this.faltamdias = Math.ceil(
            moment(prazo, "DD/MM/YYYY").diff(moment(), "days", true)
          );
        });
      } else {
        this.$router.push("/login");
      }
    });
  },
  methods: {
    updateDados: function(item, value) {
      let updates = {};
      let valuetrim = value.trim();
      updates["/users/" + this.emailkey + "/" + item] = valuetrim;
      updates[
        "/projetos/" +
          this.usuario.projeto.atual +
          "/formandos/" +
          this.emailkey +
          "/" +
          item
      ] = valuetrim;
      updates["/find/" + this.emailkey + "/" + item] = valuetrim;
      return this.$db.ref().update(updates);
    },
    updatePais: function(item, value) {
      let updates = {};
      let valuetrim = value.trim();
      updates["/users/" + this.emailkey + "/" + item] = valuetrim;
      updates[
        "/projetos/" +
          this.usuario.projeto.atual +
          "/formandos/" +
          this.emailkey +
          "/" +
          item
      ] = valuetrim;
      return this.$db.ref().update(updates);
    },
    updatePaisIm: function(item, value) {
      let updates = {};
      updates["/users/" + this.emailkey + "/" + item] = value;
      updates[
        "/projetos/" +
          this.usuario.projeto.atual +
          "/formandos/" +
          this.emailkey +
          "/" +
          item
      ] = value;
      return this.$db.ref().update(updates);
    }
  }
};
</script>
<style lang="stylus">
.nome
  font-size: 34px
  margin: 0
.sobrenome
  font-size: 20px
  margin: 0 0 20px 0
</style>



// WEBPACK FOOTER //
// src/views/AppMainDados.vue